import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { FormHelperText } from '@mui/material'
import CustomButton from '../components/styled/CustomButton'
import { useState } from 'react'
import OnboardingVideoModal from './OnboardingVideo'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const VerifyYourNumberModal = ({
  handleVerifyYourNumberModal,
  modalOpen = false,
}) => {
  const [phoneNumber, setPhoneNumber] = React.useState('+1 234 567 890')
  const [toggleOnboardingModal, setToggleOnboardingModal] = useState(false)
  const [verifyPhoneNumber, setVerifyPhoneNumber] = React.useState(false)

  const handleOnboardingVideoModal = () => {
    if (modalOpen) {
      handleVerifyYourNumberModal(false)
    }
    setToggleOnboardingModal(!toggleOnboardingModal)
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={() => handleVerifyYourNumberModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h3 className="fs-24 mb-3 fw-bold">Verify Your Number</h3>
          <p className="fs-16 color-primary mb-4">
            Please enter your Country & <br /> you Phone Number
          </p>
          <div className="mt-3 phone-input" id="phone-input">
            <FormHelperText id="input-label" margin="dense">
              Phone Number
            </FormHelperText>
            <PhoneInput
              value={phoneNumber}
              onChange={(phoneNumber) => setPhoneNumber(phoneNumber)}
              inputProps={{
                name: 'phoneNumber',
                required: true,
                autoFocus: true,
              }}
            />
          </div>
          {!verifyPhoneNumber && (
            <Button
              disableElevation
              variant="contained"
              id="btn-primary-no-shadow"
              className="pointer mt-5"
              fullWidth={true}
              onClick={() => setVerifyPhoneNumber(true)}
            >
              Send
            </Button>
          )}
          {verifyPhoneNumber && (
            <div>
              <Button
                disableElevation
                variant="contained"
                className="pointer mt-5"
                id="btn-primary-no-shadow"
                fullWidth={true}
                onClick={handleOnboardingVideoModal}
              >
                Verify
              </Button>
              <CustomButton
                className="mt-2"
                fullWidth={true}
                title={'Resend Code'}
                color={'#08C4BB'}
                border={'1px solid #08C4BB'}
                background={'transparent'}
              />
            </div>
          )}
        </Box>
      </Modal>
      {/* {toggleOnboardingModal && ( */}
        <OnboardingVideoModal
          handleOnboardingVideoModal={handleOnboardingVideoModal}
          modalOpen={toggleOnboardingModal}
        />
      {/* )} */}
    </div>
  )
}

export default VerifyYourNumberModal
